/* eslint-disable react/no-direct-mutation-state */
import { Component } from 'react';
import { CheckBox, Form, Lookup, NumberBox, Popup, RadioGroup, TagBox, TextArea, TextBox } from 'devextreme-react';
import { SelectBox, Item as SbItem } from 'devextreme-react/select-box.js';
import { ButtonItem, ButtonOptions, EmptyItem, SimpleItem, Label } from 'devextreme-react/form';
import Marquee from 'react-fast-marquee';
import { isMobile } from 'react-device-detect';
import CollapsibleBox from '../utils/CollapsibleBox.jsx';
import TarikhTimePicker from '../TarikhTimePicker.jsx';
import { apiGetP, apiPostNoBodyP, apiPostP } from '../../GanjiTools.jsx';
import Inline from '../Inline.jsx';
import './LoadOrder.css';
import Card from '../utils/Card.jsx';
import Theme from '../theme/Theme.jsx';
import { style } from 'typestyle';
import StepCounter from '../utils/StepCounter.jsx';
import SideDivider from '../layout/SideDivider.jsx';
import FontAwesomeIcon from '../utils/FontAwesomeIcon.jsx';
import MinimalButton from '../MinimalButton.jsx';


export const cardStyle = {
    display: 'flex', padding: '0.25rem 1rem', borderRadius: '1rem',
    margin: '0 0.25rem', background: '#ddd',
    alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
};


class LoadOrder extends Component {
    state = {
        width: this.props.width ?? (isMobile ? '90vw' : '50vw'),
        loadOrder: this.props.loadOrder ?? { id: this.props.id > 0 ? this.props.id : 0 },
        tempCol: this.props.tempCol ?? {
            loadingTimeFrom: '',
            loadingTimeTo: '',
            fromProvinceId: 0,
            fromCityId: 0,
            destinations: [],
            companies: [],
            companyIds: [],
        },
        provinces: [],
        cities: [],
        allTruckTypes: [],
        allCompanies: [],
        currWizardStepIx: 0,
    };

    loadEnumsP = () => new Promise((resolve, reject) => {
        apiGetP(`/api/rahKala/enums`)
            .then(res => {
                res ??= {};
                //console.log('enums are loaded:');
                //console.log(res);
                resolve(res);
            })
            .catch(reject)
    });

    loadLoadOrderP = (id, companyId) => new Promise((resolve, reject) => {
        if (id !== 'new' && !(id > 0)) {
            resolve({ loadOrder: { id: 0 }, tempCol: {} });
            //reject?.('id is not positive');
            return;
        }

        if (!(companyId > 0))
            companyId = 0;

        apiGetP(`/api/rahKala/loadOrder?id=${id}&companyId=${companyId}`)
            .then(res => {
                let { error, loadOrder, tempCol } = res ?? { error: 'no responce' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                //tempCol = { ...tempCol, companyIds: tempCol?.companies?.map(x => x.id) };
                console.log('Single loadOrder loaded:');
                console.log(loadOrder, tempCol);
                resolve({ loadOrder, tempCol });
            })
            .catch(reject);
    });

    loadAllTruckTypesP = () => new Promise((resolve, reject) => {
        apiGetP('/api/dyna/rows/truckType')
            .then(res => {
                let { error, list } = res ?? { error: 'no response' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                resolve(list ?? []);
            })
            .catch(reject);
    });

    loadProvincesP = () => new Promise((resolve, reject) => {
        apiGetP('/api/rahkala/province')
            .then(provinces => {
                provinces = [{ id: 0, name: '(همه)' }, ...provinces];
                if (provinces?.length > 0) {
                    resolve(provinces);
                    return;
                }
                reject?.('error loading provinces');
            })
            .catch(reject);
    });

    loadCitiesP = (provinceId, setState) => new Promise((resolve, reject) => {
        apiGetP(`/api/rahkala/city?province=${provinceId ?? 0}`)
            .then(cities => {
                if (cities?.length > 0) {
                    if (setState)
                        this.setState({ cities }, () => resolve?.(cities));
                    else
                        resolve?.(cities);
                }
                reject?.('error loading cities');
            })
            .catch(reject);
    });

    loadAllCompaniesP = () => new Promise((resolve, reject) => {
        apiGetP('/api/dyna/rows/company')
            .then(res => {
                let { error, list } = res ?? { error: 'no response' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                resolve(list ?? []);
            })
            .catch(reject);
    });

    loadApplicableTruckSpecsP = requiredTruckTypes => new Promise((resolve, reject) => {
        apiGetP(`/api/rahkala/applicableSpecs?truckTypeIds=${requiredTruckTypes ?? ''}`)
            .then(res => {
                let { error, list } = res ?? { error: 'no response' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                resolve(list ?? []);
            })
            .catch(reject);
    });

    // onFromProvinceChanged = provinceId => {
    //     this.state.tempCol.fromProvinceId = provinceId;
    //     this.forceUpdate();
    //     //this.loadCitiesP(provinceId, true).catch(window.notif).then();
    // }

    onToProvinceChanged = provinceId => {
        this.state.toProvinceId = provinceId;
        this.forceUpdate();
        //this.loadCitiesP(provinceId, true).catch(window.notif).then();
    }

    stl = {
        marginTop: '1rem', width: this.state.width, padding: this.props.wizardMode ? '3rem' : '1rem', background: 'whitesmoke',
        borderRadius: '1rem', height: '100%', overflow: 'auto', // MasterLayout.bodyHeight + 'px'
    };

    /*  renderCards =  (prefix, items, displayExpr) => {
        if (!(items?.length > 0))
            return <></>;

        displayExpr ??= x => x;

        return (
            <Inline spacing='5px' style={{ margin: '0 1rem', fontSize: '0.9rem' }}>
                {prefix?.length > 0 && <span>{prefix}</span>}
                {
                    items.map(i => (
                        <div style={{ ...cardStyle }} key={displayExpr(i)}
                        >
                            {displayExpr(i)}
                        </div>
                    ))
                }
            </Inline>
        );
    }
    */

    renderCollapsibleForm = (title, summary, items, key, alignLabels, width) => {
        return (
            <CollapsibleBox width={width ?? this.state.width} opened={this.props.collapsed !== true}
                hideCollapseButton={this.props.wizardMode === true}
                key={key ?? `${title + this.state.loadOrder.id}_${this.props.collapsed}`}
                className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                style={{ width: this.state.width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                title={
                    <div className='loadorder-title'
                        style={{
                            height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                            justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                        }}
                    >
                        <span style={{ fontWeight: '900' }}>{title}</span>
                    </div>
                }
                headerStyle={{
                    width: `calc(${width ?? this.state.width} - ${this.props.wizardMode ? -2 : 2}rem)`,
                    background: Theme.col1('whitesmoke'),
                    color: Theme.col0(),
                }}
                summary={
                    <span className='loadorder-summary'
                        style={{
                            margin: '0 1rem', fontSize: '0.8rem',
                            color: Theme.col2('#550')
                        }}
                    >
                        {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                    </span>
                }

                //farItems={[
                // <a href={apiPrefix + '/' + qr.answersUrl} download key='asdf'
                //     style={{ textDecoration: 'none' }}
                // >
                //     <MinimalButton text='دانلود پاسخ های داده شده' icon='download'
                //         style={{ fontWeight: '700', padding: '1rem' }}
                //     />
                // </a>
                //]}
                bodyStyle={{
                    ...this.props.style, ...this.stl, marginTop: '0',
                    borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                    width: `calc(${width ?? this.state.width} - 2rem)`,
                    background: Theme.col1('whitesmoke'),
                }}
            >
                <Form rtlEnabled colCount={60} width='100%' key={key} // width='50vw'
                    alignItemLabels={alignLabels !== false} alignItemLabelsInAllGroups={alignLabels !== false}
                    className='loadorder-form'
                >
                    {items?.props?.children}
                </Form>
            </CollapsibleBox>
        );
    }

    updLoadOrder = (upd, whenDone) => {
        upd(this.state.loadOrder);
        this.forceUpdate(whenDone);
    }

    onTruckTypesChanged = truckTypes => {
        this.state.loadOrder.requiredTruckTypes = truckTypes?.reduce((a, b) => `${a} ${b}`, '')?.trim()?.replaceAll(' ', ',');

        this.loadApplicableTruckSpecsP(this.state.loadOrder.requiredTruckTypes)
            .then(applicableTruckSpecs => this.setState({ applicableTruckSpecs }))
            .catch(window.notif);
    }

    onSave = () => {
        if (this.state.loadOrder.isGeneral)
            this.state.tempCol.companies = [];

        this.state.tempCol.companyIds = this.state.tempCol.companies?.map(x => x.id);

        // {...this.state.tempCols, companies:null, truckTypes:null, truckSpecs:null}
        this.state.loadOrder.tempCol = JSON.stringify(this.state.tempCol);

        console.log('saving ', this.state.loadOrder, this.state.tempCol);

        apiPostP('/api/rahKala/saveLoadOrder', this.state.loadOrder)
            .then(res => {
                let { error, dbLoadOrder } = res ?? { error: 'no response.' };
                if (error?.length > 0) {
                    window.notif('خطا در ذخیره سفارش بار: ' + error);
                    return;
                }
                if (this.state.currWizardStepIx < this.stepsCount - 1) {
                    this.state.currWizardStepIx++;
                    this.forceUpdate();
                }
                window.notif('سفارش ذخیره شد');
                console.log(dbLoadOrder);

            })
            .catch(window.notif);
    }

    onSearchDestinationTel = tel => {
        this.state._destPersonExists = false;

        tel = tel?.trim();
        if (!(tel?.length > 0)) {
            window.notif('تلفن گیرنده را وارد کنید');
            return;
        }

        this.state._destTelHasChecked = true;

        apiGetP(`/api/rahkala/person?tel=${tel}`)
            .then(res => {
                console.log('search result: ', res);

                let { person, locations } = res ?? { person: null, locations: [] };
                this.state._destPersonId = person?.id ?? 0;
                this.state._destPersonExists = person?.id > 0;
                this.state._destPersonFname = person?.firstName;
                this.state._destPersonLname = person?.lastName;
                this.state._destPersonAddresses = [...locations, { id: -1, summary: ' - آدرس جدید - ' }];
                this.state._destSelectedPersonAddress = -1;
                this.forceUpdate();
            })
            .catch(window.notif);
    }

    onAddDestination = () => {
        this.state.tempCol.destinations ??= [];

        let newDest = {
            id: -this.state.tempCol.destinations.length - 1,
            comment: this.state._destComment,
            tonnage: this.state._destTonnage ?? 0
        };

        if (this.state._destPersonExists && this.state._destSelectedPersonAddress > 0) {
            newDest.fK_PersonLocation = this.state._destSelectedPersonAddress;
            let toLocation = this.state._destPersonAddresses?.find(x => x.id === newDest.fK_PersonLocation)?.location;
            newDest.summary = `${toLocation?.city ?? toLocation?.summary ?? ''}: ${newDest.tonnage > 0 ? newDest.tonnage + ' تن' : ''}`;
            //newDest.auxCol = { toLocation };
        }
        else {
            newDest.auxCol = {
                toPerson: {
                    id: this.state._destPersonId,
                    firstName: this.state._destPersonFname,
                    lastName: this.state._destPersonLname,
                    tel: this.state._destPersonTel,
                },
                toLocation: {
                    cityId: this.state._destCityId,
                    city: this.state.cities?.find(x => x.id === this.state._destCityId)?.name,
                    address: this.state._destAddress
                },
            };
            newDest.summary = `${newDest.auxCol?.toLocation?.city}:${newDest.tonnage} تن`;
        }

        this.state.tempCol.destinations.push(newDest);
    };

    clearDestinationForm = thenForeUpdate => {
        this.state._destAddress = '';
        this.state._destComment = '';
        this.state._destPersonFname = '';
        this.state._destPersonLname = '';
        this.state._destPersonTel = '';
        this.state._destPersonExists = false;
        this.state._destProvinceId = null;
        this.state._destCityId = null;
        this.state._destSelectedPersonAddress = null;
        this.state._destTonnage = 0;
        this.state._destTelHasChecked = false;
        if (thenForeUpdate)
            this.forceUpdate();
    }

    costOffer = (act, loadOrderId, companyId, companyOfferedCost) => {
        console.log('company is going to put an offer or reject it... ', act, loadOrderId, companyId, companyOfferedCost);

        if (!(companyOfferedCost > 0))
            companyOfferedCost = 0;

        if (!(companyId > 0)) {
            window.notif('Invalid company!');
            return;
        }

        apiPostNoBodyP(`/api/rahKala/companyOfferCost/${act}?loadOrderId=${loadOrderId}&companyId=${companyId}&cost=${companyOfferedCost}`)
            .then(res => {
                let { error, warning } = res ?? { error: 'No response.', warning: '' };

                if (error?.length > 0) {
                    window.notif(res.error);
                    return;
                }
                window.notif('ثبت شد');
                if (warning)
                    console.log(warning);
            })
            .catch(window.notif);
    }

    componentDidMount() {
        if (this.props.loadOrder) {
            Promise.all([
                this.loadEnumsP(),
                this.loadProvincesP(),
                this.loadCitiesP(),
                this.loadAllTruckTypesP(),
                this.loadAllCompaniesP(),
                this.loadApplicableTruckSpecsP(),
            ])
                .then(([enums, provinces, cities, allTruckTypes, allCompanies, applicableTruckSpecs]) => this.setState({ enums, provinces, cities, allTruckTypes, allCompanies, applicableTruckSpecs }))
                .catch(window.notif);

            return;
        }

        this.loadLoadOrderP(this.state.loadOrder.id)
            .then(({ loadOrder, tempCol, dealTypes }) => {
                this.state.loadOrder = loadOrder;
                this.state.tempCol = tempCol;
                this.state.dealTypes = dealTypes;

                console.log(loadOrder);
                console.log(tempCol);

                Promise.all([
                    this.loadEnumsP(),
                    this.loadProvincesP(),
                    this.loadCitiesP(),
                    this.loadAllTruckTypesP(),
                    this.loadAllCompaniesP(),
                    this.loadApplicableTruckSpecsP()
                ])
                    .then(([enums, provinces, cities, allTruckTypes, allCompanies, applicableTruckSpecs]) => this.setState({ enums, provinces, cities, allTruckTypes, allCompanies, applicableTruckSpecs }))
                    .catch(window.notif);
            })
            .catch(window.notif);
    }

    labelsClass = style({ color: Theme.col3() });

    render() {
        let r = this.state.loadOrder ?? {};

        let requiredTruckTypes = JSON.parse(`[${r.requiredTruckTypes?.replaceAll(',', ' ')?.trim()?.replaceAll(' ', ',') ?? ''}]`);
        let requiredTruckSpecs = JSON.parse(`[${r.requiredTruckSpecs?.replaceAll(',', ' ')?.trim()?.replaceAll(' ', ',') ?? ''}]`);
        let assignedCompanies = this.state.tempCol.assignedCompanies?.reduce((a, b) => `${a} | ${b.name}`, '').substr(2) ?? '';
        // let nco = this.state.tempCol.companies?.length ?? 0;
        // let tenderMethod = assignedCompanies?.length > 0 ? 'مختص شرکت ' + assignedCompanies
        //     : nco > 1 ? `مناقصه محدود بین ${nco} شرکت`
        //         : nco === 1 ? 'مختص شرکت ' + this.state.tempCol.companies[0].name    //this.state.allCompanies.find(x => x.id === this.state.tempCol.companies[0])?.name
        //             : 'مناقصه کلی';

        let dealTypeNames = this.state.enums?.loadOrder?.dealTypes ?? [];
        let readOnly = this.props.readOnly || this.props.userRole !== 'orderer';
        let titles = ['معیار تخصیص شرکت', 'مشخصات بار', ' مبدأ و مقصد ', 'ناوگان'];
        //let canPutOffer = this.props.userRole === 'company' && (this.state.tempCol.canPutOffer ?? 'cannot') !== 'cannot';
        let canPutOffer = this.props.userRole === 'company' && ((this.state.tempCol.canPutOffer ?? 'cannot') !== 'cannot' || this.state.tempCol.canRejectOffer);

        // if (this._canPutOffer !== this.state.tempCol.canPutOffer) {
        //     this._canPutOffer = this.state.tempCol.canPutOffer;
        //     this.props.onCanPutOfferChanged?.(this._canPutOffer, canPutOffer);
        // }

        if (canPutOffer)
            titles.push('پیشنهاد');

        this.stepsCount = titles.length;

        let offerFormWidth = '25rem';

        let renderOfferForm = () => (
            !canPutOffer ? <></> :
                <div style={{
                    margin: '2px', padding: '1rem', height: 'calc(97% - 2rem)', background: Theme.col3('whitesmoke'),
                    display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '1rem',
                }}>
                    <Form rtlEnabled colCount={60} width={offerFormWidth} //height='100%'
                    >
                        <SimpleItem colSpan={60}
                            render={() => (
                                <div className='loadorder-title'
                                    style={{
                                        height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                                        justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                                        marginBottom: '2rem'
                                    }}
                                >
                                    <span style={{ fontWeight: '900', fontSize: '1rem' }}>{r.dealType === 0 ? 'قبول بار' : 'شرکت در مناقصه'}</span>
                                </div>
                            )}
                        />

                        <SimpleItem colSpan={60}>
                            <Label text='قیمت موردنظر' />
                            {r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept'
                                ?
                                <NumberBox readOnly rtlEnabled={false} value={r.cost} />
                                :
                                <NumberBox rtlEnabled={false} value={this.state.tempCol.companyOfferedCost}
                                    readOnly={this.state.tempCol.canPutOffer !== 'canputcost' && this.state.tempCol.canPutOffer !== 'canchangecost'}
                                    onValueChanged={e => {
                                        this.state.tempCol.companyOfferedCost = e.value; // فقط برای استفاده در دکمه ثبت پیشنهاد
                                        this.forceUpdate();
                                    }}
                                />
                            }
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        {this.state.tempCol.canPutOffer !== 'cannot' &&
                            <ButtonItem colSpan={60}>
                                <ButtonOptions //text={r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept' ? 'قبول پیشنهاد' : 'ثبت پیشنهاد'}
                                    type='success' width='100%'
                                    render={() => (
                                        <MinimalButton
                                            //text={r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept' ? ' قبول پیشنهاد ' : ' ثبت پیشنهاد '}
                                            text={this.state.tempCol.canPutOffer === 'canaccept' ? 'قبول پیشنهاد'
                                                : this.state.tempCol.canPutOffer === 'canputcost' ? ' ثبت پیشنهاد '
                                                    : this.state.tempCol.canPutOffer === 'canchangecost' ? 'اصلاح پیشنهاد' : '??'
                                            }
                                            icon='fa-handshake' iconType='solid' highlightedBackground='transparent'
                                            iconEffects={{ beat: true }} iconSize='1rem'
                                        />
                                    )}

                                    onClick={() => this.costOffer(r.dealTypeEnumName === 'fixedcost' ? 'accept' : 'setcost',
                                        r.id, this.state.tempCol.currentCompanyId, this.state.tempCol.companyOfferedCost)
                                    }
                                />
                            </ButtonItem>
                        }
                        {this.state.tempCol.canRejectOffer &&
                            <ButtonItem colSpan={60}>
                                <ButtonOptions //text='رد پیشنهاد'
                                    type='danger' width='100%'
                                    render={() => (
                                        <MinimalButton text=' رد پیشنهاد ' icon='fa-handshake-slash' iconType='solid'
                                            highlightedBackground='transparent' iconSize='1rem'
                                        />
                                    )}

                                    onClick={() => this.costOffer('reject', r.id, this.state.tempCol.currentCompanyId)}
                                />
                            </ButtonItem>
                        }
                    </Form>
                </div>
        );

        this.state.width = canPutOffer && window.config.FULL_WIDTH_CARDS ? `calc(${this.props.width} - ${offerFormWidth} - 2rem)` : this.state.width;

        let renderSpecs = () => (
            <Inline rtlEnabled spacing='2px' style={{
                justifyContent: 'center',
                height: window.config.LOADORDER_WIZARD_MODE && !canPutOffer ? '100%' : 'auto'
            }}
            >
                <div style={this.props.style} className={this.props.className}>
                    {readOnly !== true && this.props.wizardMode &&
                        <StepCounter
                            texts={titles}
                            style={{ padding: '1rem', width: '95%' }}
                            onItemClick={(_, ix) => this.setState({ currWizardStepIx: ix })}
                            secondaryColorIf={(_, ix) => ix !== this.state.currWizardStepIx}
                            primaryColor='green' secondaryColor='gray'
                        />
                    }

                    {(!this.props.wizardMode || this.state.currWizardStepIx === 0) &&
                        this.renderCollapsibleForm('معیار تخصیص شرکت',
                            <>
                                <Inline>
                                    {Card.renderCards(
                                        (dealTypeNames?.find(x => x.id === r.dealType)?.summary ?? '') + ' '
                                        + (r.dealType === 0 ? (this.state.tempCol?.companies?.length > 0 ? this.state.tempCol.companies[0]?.summary ?? '' : '') : '')
                                        //+ (r.isCostCompetitive === true && r.dealType !== 0 ? ' (رقابتی)' : ' (غیر رقابتی)')
                                        ,
                                        [r.dealType === 0 || !r.isGeneral ? ' محدود ' : ' عمومی '])
                                    }
                                    <span>{r.statusName + (!(assignedCompanies.length > 0) ? '' : (': ' + assignedCompanies))}</span>
                                </Inline>
                            </>,
                            <>
                                <SimpleItem cssClass={this.labelsClass} colSpan={30}
                                >
                                    <Label render={e => e.text} text='معیار تخصیص' />
                                    <SelectBox dataSource={dealTypeNames} displayExpr='summary' valueExpr='id' rtlEnabled
                                        className={style({
                                            '& *': {
                                                color: Theme.col2() + ' !important',
                                            }
                                        })}
                                        layout='horizontal'
                                        readOnly={readOnly}
                                        value={r.dealType} placeholder='انتخاب  معیار تخصیص شرکت (ها)'
                                        onValueChanged={e => {
                                            r.dealType = e.value;
                                            r.dealTypeEnumName = r.dealType >= 0 ? dealTypeNames[r.dealType] : '';
                                            this.forceUpdate();
                                        }}
                                    />
                                </SimpleItem>

                                {r.dealType === 0 &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={30}
                                    //visible={!this.props.readOnly && this.state.tempCol.tenderIsRunning && !(assignedCompanies?.length > 0)}
                                    >
                                        <Label render={e => e.text} text='انتخاب شرکت' />
                                        <SelectBox dataSource={this.state.allCompanies}
                                            rtlEnabled displayExpr='name' valueExpr='id' placeholder='شرکت مورد نظر را انتخاب کنید'
                                            readOnly={this.props.readOnly || this.state.tempCol.tenderIsRunning === false}
                                            value={this.state.tempCol.companyIds?.length > 0 ? this.state.tempCol.companyIds[0] : null}
                                            onValueChanged={e => {
                                                this.state.tempCol.companyIds = [e.value]
                                                this.state.tempCol.companies = [this.state.allCompanies.find(x => x.id === e.value)];
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {r.dealType !== 0 /* reserve */ &&
                                    <SimpleItem colSpan={15}>
                                        <Label render={e => e.text} text='مناقصه عمومی' />
                                        <CheckBox rtlEnabled
                                            readOnly={readOnly}
                                            value={r.isGeneral === true}
                                            onValueChanged={e => {
                                                r.isGeneral = e.value === true;
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {(r.dealType === 1/*fixedquality*/ || r.dealType === 3 /*useexpression*/) &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={15}
                                    >
                                        <Label render={e => e.text} text='قیمت رقابتی' />
                                        <CheckBox rtlEnabled hint='قیمت پیشنهادی برای دیگران قابل رؤیت باشد'
                                            readOnly={readOnly}
                                            value={r.isCostCompetitive === true}
                                            onValueChanged={e => {
                                                r.isCostCompetitive = e.value === true;
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {r.dealType !== 0 && r.dealType !== 1 && r.dealType !== 3 &&
                                    <EmptyItem colSpan={15} />
                                }

                                {r.dealType !== 0 /* reserve */ &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={60}
                                    >
                                        <Label render={e => e.text} text='معیار کیفیت شرکتها' />
                                        <TextBox rtlEnabled className='mdh-left-align'
                                            placeholder={this.props.readOnly ? 'پیش فرض' : '@{np} * @{nt} * @{age} برای مثال '}
                                            readOnly={readOnly}
                                            value={r.jsCompanyEvaluation}
                                            onValueChanged={e => {
                                                r.jsCompanyEvaluation = e.value;
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {r.dealType === 3/* useExpression */ &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={60}
                                    >
                                        <Label render={e => e.text} text='معیار ارزش پیشنهادها' />
                                        <TextBox rtlEnabled={false} className='mdh-left-align'
                                            placeholder={this.props.readOnly ? 'پیش فرض' : '@{q} / @{p} برای مثال'}
                                            readOnly={readOnly}
                                            value={r.jsDealEvaluation}
                                            onValueChanged={e => {
                                                r.jsDealEvaluation = e.value;
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {(r.dealType == 1/*fixedquality*/ || r.dealType === 3/* useExpression */) &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={60}
                                    >
                                        <Label render={e => e.text} text='حداقل کیفیت قابل قبول' />
                                        <NumberBox rtlEnabled={false} className='mdh-left-align'
                                            readOnly={readOnly}
                                            value={r.minAcceptableQuality}
                                            onValueChanged={e => {
                                                r.minAcceptableQuality = e.value;
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {r.dealType !== 0 && !r.isGeneral &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={60}
                                        visible={!this.props.readOnly && this.state.tempCol.tenderIsRunning && !(assignedCompanies?.length > 0)}>
                                        <Label render={e => e.text} text='افزودن شرکت' />
                                        <Lookup dataSource={this.state.allCompanies.filter(a => !this.state.tempCol.companyIds?.includes(a.id))}
                                            rtlEnabled displayExpr='name' valueExpr='id'
                                            value={this.state._companyId} placeholder='برای افزودن شرکت کلیک کنید'
                                            onValueChanged={e => {
                                                this.state.tempCol.companies ??= [];
                                                if (e.value > 0 && !this.state.tempCol.companies.find(x => x.id === e.value)) {
                                                    this.state.tempCol.companies.push(this.state.allCompanies.find(x => x.id === e.value));
                                                    this.state.tempCol.companyIds = this.state.tempCol.companies?.map(x => x.id);
                                                }

                                                this.state._companyId = null;
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                {r.dealType !== 0 && !r.isGeneral &&
                                    <SimpleItem cssClass={this.labelsClass} colSpan={60}>
                                        <Label render={e => e.text} text='شرکت(های) انتخاب شده' />
                                        <TagBox rtlEnabled dataSource={this.state.tempCol.companies} //{this.state.allCompanies.filter(x => this.state.tempCol.companies?.includes(x.id))}
                                            readOnly={this.props.readOnly || this.state.tempCol.tenderIsRunning === false || assignedCompanies?.length > 0}
                                            hideSelectedItems
                                            valueExpr='id' displayExpr='name'
                                            value={this.state.tempCol.companyIds} placeholder='همه شرکت ها (مناقصه عمومی)' // .companies?.map(x => x.id)
                                            onValueChange={v => {
                                                this.state.tempCol.companyIds = v ?? [];
                                                this.state.tempCol.companies = this.state.allCompanies.filter(a => this.state.tempCol.companyIds?.includes(a.id));
                                                this.forceUpdate();
                                            }}
                                        />
                                    </SimpleItem>
                                }

                                <SimpleItem cssClass={this.labelsClass} colSpan={30} visible={!(assignedCompanies?.length > 0)}
                                >
                                    <Label render={e => e.text} text={r.dealType === 0 ? 'مهلت پاسخ شرکت' : 'مهلت مناقصه تا'} />
                                    <TarikhTimePicker value={r.tenderEndTime} key={'tet_' + r.id} // {this.state.tempCol.loadingTarikhTo}
                                        readOnly={readOnly}
                                        onValueChanged={e => this.state.tempCol.tenderEndTime = e.value}
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={assignedCompanies?.length > 0 ? 60 : 30}
                                >
                                    <Label render={e => e.text} text='وضعیت' />
                                    <TextBox readOnly
                                        text={r.statusName + (!(assignedCompanies.length > 0) ? '' : (': ' + assignedCompanies))}
                                        stylingMode='outlined'
                                    />
                                </SimpleItem>
                            </>
                        )
                    }

                    {(!this.props.wizardMode || this.state.currWizardStepIx === 1) &&
                        this.renderCollapsibleForm('مشخصات بار', `${r.name ?? ''} ⬥ ${r.comment ?? ''}`,
                            <>
                                <SimpleItem cssClass={this.labelsClass} colSpan={30}>
                                    <Label render={e => e.text} text='عنوان بار' />
                                    <TextBox value={r.name} onValueChanged={e => this.updLoadOrder(r => r.name = e.value)}
                                        readOnly={readOnly}
                                        placeholder='عنوان کالا را وارد کنید'
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={30}>
                                    <Label render={e => e.text} text='بسته بندی' />
                                    <TextBox value={r.package} onValueChanged={e => this.updLoadOrder(r => r.package = e.value)}
                                        readOnly={readOnly}
                                        placeholder='نوع بسته بندی'
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={60}>
                                    <Label render={e => e.text} text='توضیح' />
                                    <TextBox value={r.comment} onValueChanged={e => this.updLoadOrder(r => r.comment = e.value)}
                                        readOnly={readOnly}
                                    />
                                </SimpleItem>
                            </>
                        )
                    }

                    {(!this.props.wizardMode || this.state.currWizardStepIx === 2) &&
                        this.renderCollapsibleForm(' مبدأ و مقصد ',
                            <>
                                {Card.renderCards('از ' + (this.state.cities?.find(x => x.id === this.state.tempCol.fromCityId)?.name ?? '') + ' به ',
                                    this.state.tempCol.destinations,
                                    x => x.summary
                                )}
                            </>,
                            <>
                                <SimpleItem cssClass={this.labelsClass} colSpan={30}>
                                    <Label render={e => e.text} text='زمان بارگیری از' />
                                    <TarikhTimePicker value={r.loadingTimeFrom} key={'t1_' + r.id} // this.state.tempCol.loadingTarikhFrom}                             
                                        readOnly={readOnly}
                                        onValueChanged={e => {
                                            // this.updLoadOrder(r => r.loadingTimeFrom = e.value);
                                            // this.state.tempCol.loadingTarikhFrom = e.tarikh;
                                            this.state.tempCol.loadingTimeFrom = e.value;
                                        }}
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={30}>
                                    <Label render={e => e.text} text='زمان بارگیری تا' />
                                    <TarikhTimePicker value={r.loadingTimeTo} key={'t2_' + r.id} // {this.state.tempCol.loadingTarikhTo}
                                        readOnly={readOnly}
                                        onValueChanged={e => {
                                            //this.updLoadOrder(r => r.loadingTimeTo = e.value)
                                            this.state.tempCol.loadingTimeTo = e.value;
                                        }}
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={30}
                                >
                                    <Label render={e => e.text} text='استان مبدأ' />
                                    <Lookup dataSource={this.state.provinces} displayExpr='name' valueExpr='id' rtlEnabled
                                        //key={'provlkp_' + this.state.provinces?.length + '_' + this.state.cities?.length}
                                        //visible={this.state.provinces?.length > 0}
                                        readOnly={readOnly}
                                        value={this.state.tempCol.fromProvinceId} placeholder='انتخاب استان مبدأ'
                                        onValueChanged={e => {
                                            this.state.tempCol.fromProvinceId = e.value;
                                            this.forceUpdate();
                                        }}
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={30}>
                                    <Label render={e => e.text} text='شهر مبدأ' />
                                    <Lookup dataSource={this.state.cities.filter(x => this.state.tempCol.fromProvinceId === 0 || x.ostan === this.state.tempCol.fromProvinceId)}
                                        readOnly={readOnly}
                                        rtlEnabled displayExpr='name' valueExpr='id'
                                        value={this.state.tempCol.fromCityId} placeholder='انتخاب شهر مبدأ'
                                        onValueChanged={e => {
                                            this.state.tempCol.fromCityId = e.value;
                                            this.forceUpdate();
                                        }}
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={this.props.readOnly ? 60 : 50}
                                >
                                    <Label render={e => e.text} text='شهرهای مقصد' />
                                    <TagBox rtlEnabled dataSource={this.state.tempCol.destinations} //key={'dests_' + this.state._cityId}
                                        readOnly={readOnly}
                                        searchMode='startswith' searchEnabled hideSelectedItems
                                        valueExpr='id'
                                        displayExpr={dest => dest.summary ?? `${dest.auxCol?.toLocation?.city}: ${dest.tonnage > 0 ? dest.tonnage + ' تن' : ''}`}
                                        value={this.state.tempCol.destinations?.map(x => x.id)} placeholder='مقصدهای انتخاب شده'
                                        onValueChange={v => {
                                            this.state.tempCol.destinations = this.state.tempCol.destinations?.filter(x => v?.includes(x.id));
                                            this.state.tempCol.destinations ??= [];
                                            this.forceUpdate();
                                        }}
                                    />
                                </SimpleItem>

                                {!this.props.readOnly &&
                                    <ButtonItem rtlEnabled colSpan={10}>
                                        <ButtonOptions rtlEnabled text='افزودن' icon='plus' width='100%' type='success'
                                            onClick={() => {
                                                this.clearDestinationForm();
                                                this.setState({ destPopVisible: true });
                                            }}
                                        />
                                    </ButtonItem>
                                }
                            </>
                        )
                    }

                    {(!this.props.wizardMode || this.state.currWizardStepIx === 3) &&
                        this.renderCollapsibleForm('ناوگان',
                            <Inline>
                                {Card.renderCards('', this.state.allTruckTypes?.filter(s => requiredTruckTypes?.includes(s.id)), x => x.name)}
                                <span style={{ opacity: '50vw' }}> مشخصات: </span>
                                {Card.renderCards('', this.state.applicableTruckSpecs?.filter(s => requiredTruckSpecs?.includes(s.id)), x => x.name)}
                            </Inline>,
                            <>
                                <SimpleItem cssClass={this.labelsClass} colSpan={60}>
                                    <Label render={e => e.text} text='نوع' />
                                    <TagBox rtlEnabled dataSource={this.state.allTruckTypes}
                                        readOnly={readOnly}
                                        valueExpr='id' displayExpr='name'
                                        value={requiredTruckTypes} placeholder='نوع یا انواع وسیله نقلیه را مشخص کنید'
                                        onValueChange={this.onTruckTypesChanged}
                                    />
                                </SimpleItem>

                                <SimpleItem cssClass={this.labelsClass} colSpan={60}>
                                    <Label render={e => e.text} text='مشخصات' />
                                    <TagBox rtlEnabled dataSource={this.state.applicableTruckSpecs} searchEnabled hideSelectedItems
                                        readOnly={readOnly}
                                        valueExpr='id' displayExpr='name'
                                        value={requiredTruckSpecs} placeholder='مشخصات وسیله نقلیه موردنظر'
                                        onValueChange={v => r.requiredTruckSpecs = v?.reduce((a, b) => `${a} ${b}`, '')?.trim()?.replaceAll(' ', ',')}
                                    />
                                </SimpleItem>
                            </>
                        )
                    }

                    {!window.config.FULL_WIDTH_CARDS && (!this.props.wizardMode || this.state.currWizardStepIx === 4) && canPutOffer &&
                        this.renderCollapsibleForm(r.dealType === 0 ? 'قبول بار' : 'شرکت در مناقصه',
                            // assignedCompanies?.length > 0 ? Card.renderCards('', [assignedCompanies]) : ' نحوه اختصاص: ' + tenderMethod
                            //     + (!(r.statusName?.length > 0) ? '' : ` (${r.statusName})`)
                            Card.renderCards('',
                                r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept' ? ['قیمت تعیین شده توسط صاحب بار: ' + (r.cost ?? '')]
                                    : this.state.tempCol.companyOfferedCost > 0 ? ['قیمت پیشنهادی شما: ' + this.state.tempCol.companyOfferedCost]
                                        : ['پیشنهاد قیمتی نداشته اید']
                            ),
                            <>
                                <SimpleItem colSpan={30}>
                                    <Label text='قیمت موردنظر' />
                                    {r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept'
                                        ?
                                        <NumberBox readOnly rtlEnabled={false} value={r.cost} />
                                        :
                                        <NumberBox rtlEnabled={false} value={this.state.tempCol.companyOfferedCost}
                                            onValueChanged={e => {
                                                this.state.tempCol.companyOfferedCost = e.value; // فقط برای استفاده در دکمه ثبت پیشنهاد
                                                this.forceUpdate();
                                            }}
                                        />
                                    }
                                </SimpleItem>

                                <ButtonItem colSpan={15}>
                                    <ButtonOptions text={r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept' ? 'قبول پیشنهاد' : 'ثبت پیشنهاد'}
                                        type='success' width='100%'
                                        render={() => (
                                            <MinimalButton text={r.dealTypeEnumName === 'fixedcost' || this.state.tempCol.canPutOffer === 'canaccept' ? ' قبول پیشنهاد ' : ' ثبت پیشنهاد '}
                                                icon='fa-handshake' iconType='solid' highlightedBackground='transparent'
                                                iconEffects={{ beat: true }} iconSize='1rem'
                                            />
                                        )}
                                        onClick={() => this.costOffer(r.dealTypeEnumName === 'fixedcost' ? 'accept' : 'setcost', r.id, this.state.tempCol.currentCompanyId, this.state.tempCol.companyOfferedCost)}
                                    />
                                </ButtonItem>

                                <ButtonItem colSpan={15}>
                                    <ButtonOptions text='رد پیشنهاد'
                                        type='danger' width='100%'
                                        render={() => (
                                            <MinimalButton text=' رد پیشنهاد ' icon='fa-handshake-slash' iconType='solid'
                                                highlightedBackground='transparent' iconSize='1rem'
                                            />
                                        )}

                                        onClick={() => this.costOffer('reject', r.id, this.state.tempCol.currentCompanyId)}
                                    />
                                </ButtonItem>
                            </>
                        )
                    }

                    <div style={{
                        width: this.state.width, display: this.props.readOnly ? 'none' : 'flex', justifyContent: 'center',
                        margin: this.props.wizardMode ? '2rem auto' : '1rem auto'
                    }}
                    >
                        <Form colCount={60} rtlEnabled>
                            {this.props.wizardMode && this.state.currWizardStepIx > 0 &&
                                < ButtonItem colSpan={20}>
                                    <ButtonOptions text='⮞⮞ مرحله قبل'
                                        type='normal' width='15rem'
                                        onClick={() => {
                                            if (this.state.currWizardStepIx > 0) {
                                                this.state.currWizardStepIx--;
                                                this.forceUpdate();
                                            }
                                        }}
                                    />
                                </ButtonItem>
                            }

                            <ButtonItem colSpan={this.props.wizardMode && this.state.currWizardStepIx > 0 ? 20 : 30}>
                                <ButtonOptions text={this.props.wizardMode && this.state.currWizardStepIx < this.stepsCount - 1 ? 'ثبت و ادامه  ⮜⮜' : 'ذخیره'}
                                    icon='save' type='success' width='15rem'
                                    onClick={() => this.onSave()}
                                />
                            </ButtonItem>

                            <ButtonItem colSpan={this.props.wizardMode && this.state.currWizardStepIx > 0 ? 20 : 30}>
                                <ButtonOptions text='خروج' icon='clearsquare' type='danger' width='15rem'
                                    onClick={() => this.props.onCancel?.()}
                                />
                            </ButtonItem>
                        </Form>
                    </div>
                </div>

                {window.config.FULL_WIDTH_CARDS && renderOfferForm()}

                {/******************************************** Destination popup *********************************************** */}
                {!this.props.readOnly &&
                    <Popup rtlEnabled visible={this.state.destPopVisible} width='auto' height='auto'
                        title='افزودن مقصد، گیرنده و تناژ'
                        onHidden={() => {
                            this.clearDestinationForm();
                            this.setState({ destPopVisible: false });
                        }}
                    >
                        <Form rtlEnabled colCount={60} width={isMobile ? '80vw' : '40rem'}
                            className={style({ background: Theme.col1() })}
                        >
                            <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={this.state._destTelHasChecked ? 60 : 40}>
                                <Label render={e => e.text} text='شماره گیرنده' />
                                <TextBox readOnly={this.state._destTelHasChecked}
                                    value={this.state._destPersonTel} onValueChanged={e => this.setState({ _destPersonTel: e.value })}
                                    placeholder='شماره تلفن گیرنده'
                                />
                            </SimpleItem>

                            {!this.state._destTelHasChecked &&
                                <ButtonItem colSpan={20}>
                                    <ButtonOptions text='جستجو' type='success' width='100%'
                                        onClick={() => this.onSearchDestinationTel(this.state._destPersonTel)}
                                    />
                                </ButtonItem>
                            }

                            {this.state._destTelHasChecked &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={30} >
                                    <Label render={e => e.text} text='نام' />
                                    <TextBox readOnly={this.state._destPersonExists}
                                        value={this.state._destPersonFname} onValueChanged={e => this.setState({ _destPersonFname: e.value })}
                                    />
                                </SimpleItem>
                            }

                            {this.state._destTelHasChecked &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={30} >
                                    <Label render={e => e.text} text='نام خانوادگی' />
                                    <TextBox readOnly={this.state._destPersonExists}
                                        value={this.state._destPersonLname} onValueChanged={e => this.setState({ _destPersonLname: e.value })}
                                    />
                                </SimpleItem>
                            }

                            {this.state._destPersonExists &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={60}>
                                    <Label render={e => e.text} text='آدرس' />
                                    <SelectBox items={this.state._destPersonAddresses} rtlEnabled
                                        value={this.state._destSelectedPersonAddress} onValueChanged={e => this.setState({ _destSelectedPersonAddress: e.value })}
                                        valueExpr='id' displayExpr='summary'
                                    />
                                </SimpleItem>
                            }

                            {this.state._destTelHasChecked && (!this.state._destPersonExists || !(this.state._destSelectedPersonAddress > 0)) &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={30}>
                                    <Label render={e => e.text} text='استان' />
                                    <Lookup dataSource={this.state.provinces} displayExpr='name' valueExpr='id' rtlEnabled
                                        value={this.state._destProvinceId} placeholder='انتخاب استان'
                                        onValueChanged={e => this.setState({ _destProvinceId: e.value })}
                                    />
                                </SimpleItem>
                            }

                            {this.state._destTelHasChecked && (!this.state._destPersonExists || !(this.state._destSelectedPersonAddress > 0)) &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={30}>
                                    <Label render={e => e.text} text='شهر' />
                                    <Lookup key={`citylookup_${this.state._provinceId ?? ''}`}
                                        dataSource={this.state.cities.filter(x => !(this.state._destProvinceId > 0) || x.ostan === this.state._destProvinceId)}
                                        displayExpr='name' valueExpr='id' rtlEnabled
                                        value={this.state._destCityId} placeholder='انتخاب شهر'
                                        //onValueChanged={e => this.setState({ _cityId: e.value })}
                                        onValueChanged={e => this.state._destCityId = e.value}
                                    />
                                </SimpleItem>
                            }

                            {this.state._destTelHasChecked && (!this.state._destPersonExists || !(this.state._destSelectedPersonAddress > 0)) &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={60}>
                                    <Label render={e => e.text} text='آدرس' />
                                    <TextArea value={this.state._destAddress} onValueChanged={e => this.setState({ _destAddress: e.value })}
                                    />
                                </SimpleItem>
                            }

                            {this.state._destTelHasChecked &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={30}>
                                    <Label render={e => e.text} text='تناژ' />
                                    <NumberBox rtlEnabled={false} value={this.state._destTonnage ?? 0}
                                        onValueChanged={e => this.setState({ _destTonnage: e.value })}
                                    />
                                </SimpleItem>
                            }

                            {this.state._destTelHasChecked &&
                                <EmptyItem colSpan={30} />
                            }

                            {this.state._destTelHasChecked &&
                                <SimpleItem /*cssClass={this.labelsClass}*/ colSpan={60}>
                                    <Label render={e => e.text} text='یادداشت' />
                                    <TextArea value={this.state._destComment} onValueChanged={e => this.setState({ _destComment: e.value })}
                                    />
                                </SimpleItem>
                            }

                            <EmptyItem colSpan={60} />

                            {this.state._destTelHasChecked &&
                                <ButtonItem colSpan={30} rtlEnabled>
                                    <ButtonOptions text='افزودن' width='10rem' icon='check' type='success'
                                        onClick={() => {
                                            this.onAddDestination();
                                            this.clearDestinationForm();
                                            window.notif(' اضافه شد');
                                            this.forceUpdate();
                                        }}
                                    />
                                </ButtonItem>
                            }

                            <ButtonItem colSpan={30} rtlEnabled
                            >
                                <ButtonOptions text='خروج' width='10rem' icon='close' type='danger'
                                    onClick={() => this.setState({ destPopVisible: false })}
                                />
                            </ButtonItem>

                        </Form>
                    </Popup>
                }

            </Inline>
        );

        return renderSpecs();
    }
}


export default LoadOrder;
